import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { ServicesService } from '../../services.service';
import { AppComponent } from '../../app.component';
import { Chart } from 'chart.js';
import {  } from 'chartjs-plugin-datalabels';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers: [ServicesService]
})
export class HomeComponent implements OnInit {
    constructor(private _services: ServicesService, private _appcomponent: AppComponent) {}

    chart = [];

    chartCaminhoesUlt30Dias(dados: any) {
        const label: any = [];
        const chartdata: any = [];
        for (let i = 0; i < dados.length; i++) {
            label.push(dados[i].DiaMes);
            chartdata.push(dados[i].Qtd);
        }
        this.chart = new Chart('myChart', {
            type: 'line',
            data: {
                labels: label,
                datasets: [
                    {
                        label: 'Entrada de Caminhões',
                        data: chartdata,
                        backgroundColor: 'rgba(3, 78, 162, 0.2)',
                        borderColor: 'rgba(3,78,162,1)',
                        borderWidth: 2
                    }
                ]
            },
            options: {
                responsive: true,
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true
                            }
                        }
                    ],
                    xAxes: [
                        {
                            gridLines: {
                                display: false
                            }
                        }
                    ]
                },
                animation: {
                    animateScale: true,
                    animateRotate: true,
                    duration: 1,
                    onComplete: function () {
                        const chartInstance = this.chart;
                        const ctx = chartInstance.ctx;
                        ctx.textAlign = 'center';
                        ctx.fillStyle = 'rgba(0, 0, 0, 1)';
                        ctx.textBaseline = 'bottom';
                        this.data.datasets.forEach(function (dataset, i) {
                            const meta = chartInstance.controller.getDatasetMeta(i);
                            meta.data.forEach(function (bar, index) {
                                const data = dataset.data[index];
                                ctx.fillText(data, bar._model.x, bar._model.y - 5);
                            });
                        });
                    }
                }
            }
        });
    }

    chartHorarioPico(dados: any) {
        const label: any = [];
        const chartdata: any = [];
        for (let i = 0; i < dados.length; i++) {
            label.push(dados[i].HORA);
            chartdata.push(parseFloat(dados[i].PORC));
        }
        this.chart = new Chart('horarioPico', {
            type: 'bar',
            data: {
                labels: label,
                datasets: [
                    {
                        label: 'Entrada em %',
                        data: chartdata,
                        backgroundColor: 'rgba(3, 78, 162, 0.8)',
                        borderColor: 'rgba(3,78,162,1)',
                        borderWidth: 2
                    }
                ]
            },
            options: {
                responsive: true,
                legend: {
                    display: false
                },
                tooltips: {
                    enabled: true
                },
                scales: {
                    yAxes: [
                        {
                            display: true,
                            scaleLabel: {
                                display: false,
                                labelString: 'Porcentagem'
                            },
                            ticks: {
                                display: false,
                                beginAtZero: true
                            }
                        }
                    ],
                    xAxes: [
                        {
                            scaleLabel: {
                                display: false,
                                labelString: 'Horário'
                            },
                            gridLines: {
                                display: false,
                                offsetGridLines: false
                            },
                            barPercentage: 1,
                            categoryPercentage: 0.9
                        }
                    ]
                },
                animation: {
                    duration: 1,
                    onComplete: function () {
                        const chartInstance = this.chart;
                        const ctx = chartInstance.ctx;
                        ctx.textAlign = 'center';
                        ctx.font = '12px Arial';
                        ctx.fillStyle = 'rgba(0, 0, 0, 1)';
                        ctx.textBaseline = 'bottom';
                        this.data.datasets.forEach(function (dataset, i) {
                            const meta = chartInstance.controller.getDatasetMeta(i);
                            meta.data.forEach(function (bar, index) {
                                const data = parseFloat(dataset.data[index]).toFixed(1).replace('.', ',') + '%' ; // dataset.data[index];
                                ctx.fillText(data, bar._model.x, bar._model.y + 0);
                            });
                        });
                    }
                }
            }
        });
    }

    chartTipoVeiculo(dados: any) {
        const label: any = [];
        const chartdata: any = [];
        // tslint:disable-next-line:max-line-length
        const chartbgcolor: any = ['rgba(3,78,162,0.8)', 'rgba(245,130,32,0.8)', 'rgba(237,28,36,0.8)', 'rgba(252,213,44,0.8)', 'rgba(4,155,39,0.8)'];
        // tslint:disable-next-line:max-line-length
        const chartbdcolor: any = ['rgba(3,78,162,1)', 'rgba(245,130,32,1)', 'rgba(237,28,36,1)', 'rgba(252,213,44,1)', 'rgba(4,155,39,1)'];
        let rdcolor: string;
        for (let i = 0; i < dados.length; i++) {
            label.push(dados[i].Veiculo);
            chartdata.push(dados[i].Qtd);
            if (i > 4) {
                rdcolor = Math.floor(Math.random() * 256) + ',' + Math.floor(Math.random() * 256) + ',' + Math.floor(Math.random() * 256);
                chartbgcolor.push('rgba(' + rdcolor + ',0.8)');
                chartbdcolor.push('rgba(' + rdcolor + ',1)');
            }
        }
        this.chart = new Chart('tipoveiculo', {
            type: 'bar',
            data: {
                labels: label,
                datasets: [
                    {
                        label: 'Tipo Veículo',
                        data: chartdata,
                        backgroundColor: chartbgcolor,
                        borderColor: chartbdcolor,
                        borderWidth: 2
                    }
                ]
            },
            options: {
                responsive: true,
                legend: {
                    display: false,
                    position: 'right'
                },
                animation: {
                    animateScale: true,
                    animateRotate: true,
                    duration: 1,
                    onComplete: function () {
                        const chartInstance = this.chart;
                        const ctx = chartInstance.ctx;
                        ctx.textAlign = 'center';
                        ctx.font = '12px Arial';
                        ctx.fillStyle = 'rgba(255, 255, 255, 1)';
                        ctx.textBaseline = 'top';
                        this.data.datasets.forEach(function (dataset, i) {
                            const meta = chartInstance.controller.getDatasetMeta(i);
                            meta.data.forEach(function (bar, index) {
                                const data = (Math.round(parseFloat(dataset.data[index]) * 100) / 100).toString() + ' %';
                                ctx.fillText(data, bar._model.x, bar._model.y + 5);
                            });
                        });
                    }
                }
            }
        });
    }

    chartMediaDiaria(dados: any) {
        const labels: any = [];
        const chartdata: any = [];
        chartdata[0] = [];
        chartdata[1] = [];
        chartdata[2] = [];
        chartdata[3] = [];
        const chartdatastr: any = [];
        chartdatastr[0] = [];
        chartdatastr[1] = [];
        chartdatastr[2] = [];
        chartdatastr[3] = [];
        for (let i = 0; i < dados.length; i++) {
            labels.push(dados[i].DiaMes);
            chartdata[0].push(dados[i].TMEspera);
            chartdata[1].push(dados[i].TMAtendimento);
            chartdata[2].push(dados[i].TMManobra);
            chartdata[3].push(dados[i].TMTotal);
            chartdatastr[0].push(dados[i].TMEsperaSTR);
            chartdatastr[1].push(dados[i].TMAtendimentoSTR);
            chartdatastr[2].push(dados[i].TMManobraSTR);
            chartdatastr[3].push(dados[i].TMTotalSTR);
        }
        this.chart = new Chart('mediadiaria', {
            type: 'horizontalBar',
            data: {
                labels: labels,
                datasets: [
                    {
                        label: 'Espera (min)',
                        data: chartdata[0],
                        backgroundColor: 'rgba(3, 78, 162, 0.8)',
                        borderColor: 'rgba(3,78,162,1)',
                        borderWidth: 2,
                        datastr: chartdatastr[0]
                    },
                    {
                        label: 'Baia (min)',
                        data: chartdata[1],
                        backgroundColor: 'rgba(245,130,32, 0.8)',
                        borderColor: 'rgba(245,130,32,1)',
                        borderWidth: 2,
                        datastr: chartdatastr[1]
                    },
                    {
                        label: 'Saída (min)',
                        data: chartdata[2],
                        backgroundColor: 'rgba(237,28,36, 0.8)',
                        borderColor: 'rgba(237,28,36,1)',
                        borderWidth: 2,
                        datastr: chartdatastr[2]
                    },
                    {
                        label: 'Total (min)',
                        data: chartdata[3],
                        backgroundColor: 'rgba(4,155,39, 0.8)',
                        borderColor: 'rgba(4,155,39,1)',
                        borderWidth: 2,
                        datastr: chartdatastr[3]
                    }
                ]
            },
            options: {
                responsive: true,
                legend: {
                    display: true,
                    position: 'bottom'
                },
                tooltips: {
                    enabled: true
                },
                scales: {
                    yAxes: [
                        {
                            display: true,
                            scaleLabel: {
                                display: false,
                                labelString: 'Porcentagem'
                            },
                            ticks: {
                                display: true,
                                beginAtZero: true
                            }
                        }
                    ],
                    xAxes: [
                        {
                            ticks: {
                                display: true,
                                beginAtZero: true
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Minutos'
                            },
                            gridLines: {
                                display: false,
                                offsetGridLines: false
                            },
                            barPercentage: 0.95,
                            categoryPercentage: 0.9
                        }
                    ]
                },
                animation: {
                    duration: 1,
                    onComplete: function () {
                        const chartInstance = this.chart;
                        const ctx = chartInstance.ctx;
                        ctx.textAlign = 'right';
                        ctx.fillStyle = 'rgba(255, 255, 255, 1)';
                        ctx.textBaseline = 'top';
                        this.data.datasets.forEach(function (dataset, i) {
                            const meta = chartInstance.controller.getDatasetMeta(i);
                            meta.data.forEach(function (bar, index) {
                                const data = dataset.datastr[index] + '  ' ; // dataset.data[index];
                                ctx.fillText(data, bar._model.x, bar._model.y - 5);
                            });
                        });
                    }
                }
            }
        });
    }

    chartMediaVeiculo(dados: any) {
        const labels: any = [];
        const tespera: any = [];
        const tesperastr: any = [];
        const tmanobra: any = [];
        const tmanobrastr: any = [];
        const tatendimento: any = [];
        const tatendimentostr: any = [];
        for (let i = 0; i < dados.length; i++) {
            labels.push(dados[i].TVeiculo);
            tespera.push(parseFloat(dados[i].TMEspera));
            tesperastr.push(dados[i].TMEsperaSTR);
            tatendimento.push(parseFloat(dados[i].TMAtendimento));
            tatendimentostr.push(dados[i].TMAtendimentoSTR);
            tmanobra.push(parseFloat(dados[i].TMManobra));
            tmanobrastr.push(dados[i].TMManobraSTR);
        }
        this.chart = new Chart('mediaveiculo', {
            type: 'bar',
            data: {
                labels: labels,
                datasets: [
                    {
                        label: 'Espera',
                        data: tespera,
                        backgroundColor: 'rgba(237,28,36, 0.8)',
                        borderColor: 'rgba(237,28,36,1)',
                        borderWidth: 2,
                        datastr: tesperastr
                    },
                    {
                        label: 'Baia',
                        data: tatendimento,
                        backgroundColor: 'rgba(245,130,32, 0.8)',
                        borderColor: 'rgba(245,130,32,1)',
                        borderWidth: 2,
                        datastr: tatendimentostr
                    },
                    {
                        label: 'Saída',
                        data: tmanobra,
                        backgroundColor: 'rgba(4,155,39, 0.8)',
                        borderColor: 'rgba(4,155,39,1)',
                        borderWidth: 2,
                        datastr: tmanobrastr
                    }
                ]
            },
            options: {
                responsive: true,
                legend: {
                    display: true,
                    position: 'bottom'
                },
                tooltips: {
                    enabled: false
                },
                scales: {
                    yAxes: [
                        {
                            stacked: true,
                            scaleLabel: {
                                display: true,
                                labelString: 'Tempo em Minutos'
                            },
                            ticks: {
                                beginAtZero: true
                            }
                        }
                    ],
                    xAxes: [
                        {
                            stacked: true,
                            gridLines: {
                                display: false
                            }
                        }
                    ]
                },
                animation: {
                    animateScale: true,
                    animateRotate: true,
                    duration: 1,
                    onComplete: function () {
                        const chartInstance = this.chart;
                        const ctx = chartInstance.ctx;
                        ctx.textAlign = 'center';
                        ctx.font = '12px Arial';
                        ctx.fillStyle = 'rgba(255, 255, 255, 1)';
                        ctx.textBaseline = 'top';
                        this.data.datasets.forEach(function (dataset, i) {
                            const meta = chartInstance.controller.getDatasetMeta(i);
                            meta.data.forEach(function (bar, index) {
                                const data = dataset.datastr[index];
                                ctx.fillText(data, bar._model.x, bar._model.y + 5);
                            });
                        });
                    }
                }
            }
        });
    }

    createCharts() {
        const graficos = JSON.parse('{"graficos": ["caminhoesult30dias", "horariopico", "tipoveiculo", "mediaveiculo"]}');
        this._services.requestAPIData(graficos, 'getCharData').then(reg => {
            if (reg.sucesso) {
                for (let i = 0; i < reg.graficos.length; i++) {
                    if (reg.graficos[i].sucesso) {
                        switch (reg.graficos[i].grafico) {
                            case 'caminhoesult30dias':
                                this.chartCaminhoesUlt30Dias(reg.graficos[i].dados);
                                break;
                            case 'horariopico':
                                this.chartHorarioPico(reg.graficos[i].dados);
                                break;
                            case 'tipoveiculo':
                                this.chartTipoVeiculo(reg.graficos[i].dados);
                                break;
                            case 'mediadiaria':
                                this.chartMediaDiaria(reg.graficos[i].dados);
                                break;
                            case 'mediaveiculo':
                                this.chartMediaVeiculo(reg.graficos[i].dados);
                                break;
                        }
                    }
                }
            }
        });
    }

    ngOnInit() {
        this.createCharts();
    }
}
